// This is for the staging site, which is hosted at https://next.ngrx.io
export const environment = {
    gaId: 'UA-127598155-1', // Production id (since it is linked from the main site)
    production: true,
    mode: 'next',
};
